import "./UnknownUserScreen.css";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import Translatable from "../Translatable/Translatable";


export default function UnknownUserScreen() {
  return (
    <div className="unknown-screen-container">
      <div className="unknown-alert-box">
        <SlIcon className="unknown-alert-icon" name="person-fill-x"></SlIcon>
        <div className="">
          <h2>
            <Translatable as="span" capitalize>Usuario inexistente</Translatable>
          </h2>
          <p>
            <Translatable as="span">El mail o usuario no se encuentran habilitados en la plataforma.</Translatable>
          </p>
        </div>
      </div>
    </div>
  );
}
